import { cn } from "@/lib/utils";

const STYLES: Record<string, string> = {
  forte: "bg-emerald-500/15 text-emerald-300 border-emerald-400/30",
  medio: "bg-amber-500/15 text-amber-200 border-amber-400/30",
  debole: "bg-rose-500/15 text-rose-200 border-rose-400/30",
};

export default function DiagnosisBadge({ level }: { level: "forte" | "medio" | "debole" }) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-semibold border",
        STYLES[level],
      )}
    >
      {level}
    </span>
  );
}
